import React from 'react';
import { useLocation } from 'react-router-dom';
import PrepPhaseSidebar from './PrepPhaseSidebar';
import Overview from './Overview';
import Dates from './Dates';
import ApplicationPanel from './ApplicationPanel';
import CommunicationTemplatesPanel from './CommunicationTemplatesPanel';
import LaunchPanel from './LaunchPanel';
import OverviewBase from '../OverviewBase';
import { Campaign } from '../../../../types/Campaign';

const PrepOverview = () => {
    const location = useLocation();
    const { pathname } = location;
    
    // Determine which component to render based on the current route
    const renderContentByRoute = ({ campaign, onSave, onPendingChanges }: {
        campaign: Campaign;
        onSave: (updatedCampaign: Partial<Campaign>) => Promise<Campaign>;
        onPendingChanges: (changes: Partial<Campaign>) => void;
    }) => {
        if (pathname.includes('/dates')) {
            return <Dates campaign={campaign} onSave={onSave} />;
        } else if (pathname.includes('/applications')) {
            return (
                <ApplicationPanel
                    campaign={campaign}
                />
            );
        } else if (pathname.includes('/launch')) {
            return (
                <LaunchPanel 
                    campaignId={campaign.id}
                    organizationId={campaign.organization_id}
                    isLaunched={false}
                />
            );
        } else if (pathname.includes('/communication')) {
            return (
                <CommunicationTemplatesPanel
                    campaignId={campaign.id}
                    organizationId={campaign.organization_id}
                />
            );
        } else {
            return (
                <Overview
                    campaign={campaign}
                    onSave={onSave}
                    onPendingChanges={onPendingChanges}
                />
            );
        }
    };

    return (
        <OverviewBase
            renderSidebar={() => (
                <PrepPhaseSidebar
                    sidebarCollapsed={false}
                />
            )}
            renderContent={renderContentByRoute}
        />
    );
};

export default PrepOverview;